import { registerMockAPI } from '~/mocks/mockApis';

import { skipToken, useQuery } from '@tanstack/react-query';

import { axiosInstance } from '~/services';

import { API_ENDPOINT } from '~/constants';

import { deliveryAgencyKeys } from './keys';

import type { GetCollectingRequestCandidateDetailResponse } from '~/types/delivery-agency.types';

const fetchCollectingRequestCandidateDetail = async (outboundCode: string) => {
  const { data } = await axiosInstance.get<GetCollectingRequestCandidateDetailResponse>(
    `${API_ENDPOINT.DELIVERY_AGENCY.GET_COLLECTING_REQUEST_CANDIDATE_DETAIL}/${outboundCode}`
  );
  return data.data;
};

export const useGetCollectingRequestCandidateDetailQuery = ({ outboundCode }: { outboundCode: string | null }) => {
  return useQuery({
    queryKey: deliveryAgencyKeys.collectingRequestCandidateDetail(outboundCode),
    queryFn: outboundCode ? () => fetchCollectingRequestCandidateDetail(outboundCode) : skipToken,
    staleTime: 0,
    gcTime: 1000 * 30,
  });
};

registerMockAPI<GetCollectingRequestCandidateDetailResponse>({
  method: 'get',
  endpoint: `${API_ENDPOINT.DELIVERY_AGENCY.GET_COLLECTING_REQUEST_CANDIDATE_DETAIL}/:outboundCode([A-Z]{0,}\\d[A-Z0-9]{0,})`,
  label: '배송 주문 반품 신청·조회/반품 신청 원주문 상세',
  scenarios: [
    {
      name: '정상 응답',
      response: {
        data: {
          outboundCode: 'JA9KST0000002',
          clientOrderCodes: ['0234567890023456'],
          productNames: ['컬리 유기농 샐러드 500g', '컬리 그래놀라 오리지널 400g'],
          receiverName: '김*리',
          receiverContact: '010-0000-0000',
          primaryAddress: '서울특별시 강남구 테헤란로 152 강남파이낸스센터',
          secondaryAddress: '지하 1층 물류 하역장 3번 게이트 옆',
          deliveryLocation: { code: 'DELIVERY_BOX', description: '택배 수령실' },
          deliveryLocationDetail: '택배 수령 카트 위에 올려주시고 문자 남겨주세요.',
          entranceMethod: { code: 'PUBLIC_DOOR_PWD', description: '공동현관 비밀번호' },
          entranceMethodDetail: '정문 비밀번호 #1234 입력 후 좌측 화물 엘리베이터 이용',
        },
      },
    },
    {
      name: '수령장소·출입방법 미지정',
      response: {
        data: {
          outboundCode: 'JA9KST0000003',
          clientOrderCodes: ['0234567890023457', '0234567890023458'],
          productNames: ['컬리 우유'],
          receiverName: '이*리',
          receiverContact: '010-1111-2222',
          primaryAddress: '서울특별시 송파구 문정동',
          secondaryAddress: '',
          deliveryLocation: null,
          deliveryLocationDetail: '',
          entranceMethod: null,
          entranceMethodDetail: '',
        },
      },
    },
  ],
});
